<!-- <div class="floating-shell"> -->
<section class="floating-body">
    <router-outlet></router-outlet>
</section>
<!-- </div> -->